import { ApolloCache } from '@apollo/client';

const deleteCachedFieldsOnOfferReviewPollingQuery = (cache: ApolloCache<any>): void => {
  cache.evict({ id: 'ROOT_QUERY', fieldName: 'offerReviewPollingQuery' });
  cache.gc();
};

export default deleteCachedFieldsOnOfferReviewPollingQuery;
